// 견적 버전 UI 공용 헬퍼 (목록·작성 화면·비교 모달)
export const STATUS_LABEL = { draft:'임시저장', pending_approval:'승인대기', published:'발행', unapproved_published:'미승인발행' };
export const STATUS_COLOR = { draft:'#94a3b8', pending_approval:'#f59e0b', published:'#3b82f6', unapproved_published:'#f97316' };
export const isPublished = (s) => s === 'published' || s === 'unapproved_published';

export const won = (n) => `₩${Number(n || 0).toLocaleString()}`;

// 직전(이전) 버전 대비 금액 증감: { diff, pct, text, color } — 변화 없거나 비교 불가면 null
export function amountDelta(cur, prev, withPct = true) {
  const c = Number(cur) || 0, p = Number(prev) || 0;
  const diff = c - p;
  if (diff === 0) return null;
  const pct = p > 0 ? (diff / p) * 100 : null;
  const up = diff > 0;
  return {
    diff, pct, up,
    text: `${up ? '▲' : '▼'} ${up ? '+' : '-'}${won(Math.abs(diff))}${withPct && pct != null ? ` (${up ? '+' : '-'}${Math.abs(pct).toFixed(1)}%)` : ''}`,
    color: up ? '#dc2626' : '#2563eb',
  };
}

export const dateOf = (v) => (v?.estimate_date || v?.created_at || '').slice(0, 10);
